export const EMAIL_BLOCKED_DOMAINS: Array<string> = [
    'vivawallet.com'
];
